<script>
export default {
  name: 'ImagePopup',
  data() {
    return {
      showPopup: false,
      currentImage: null
    };
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(event) {
      // Check if the clicked element or any of its parents has the 'zoomable' class
      let target = event.target;
      while (target && target !== document) {
        if (target.tagName === 'IMG' && target.classList.contains('zoomable')) {
          this.openImage(target.src);
          return;
        }
        target = target.parentNode;
      }
    },
    openImage(src) {
      this.currentImage = src;
      this.showPopup = true;
      document.addEventListener('keydown', this.handleEscape);
    },
    closeImage() {
      this.showPopup = false;
      this.currentImage = null;
      document.removeEventListener('keydown', this.handleEscape);
    },
    handleEscape(e) {
      if (e.key === "Escape") {
        this.closeImage();
      }
    }
  }
};
</script>

<template>
  <div
    v-if="showPopup"
    class="popup-overlay"
    @click.self="closeImage"
  >
    <span class="close-button" @click="closeImage">&times;</span>
    <div class="popup-content">
      <div class="popup-image-panel">
        <img :src="currentImage" class="popup-image">
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .popup-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0,0,0,0.8);
      z-index: 9999;
    }

    .popup-content {
      position: absolute;
      top: 80px;
      left: 0;
      right: 0;
      bottom: 80px;
    }

    .popup-image-panel {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: scroll;
      text-align: center;
    }

    .popup-image {
      max-width: unset;
      height: 100%;
      width: auto;
    }

    .close-button {
      position: absolute;
      top: 20px;
      right: 30px;
      font-size: 40px;
      color: white;
      cursor: pointer;
      z-index: 10000;
    }
</style>